<template>
    <v-dialog v-model="show" max-width="700px" @click:outside="$emit('close')">
        <v-card v-if="selectedDeleteItem">
            <v-card-title>
                <span class="">
                    Delete Category: <b>{{ categoryName }}</b></span
                >
                <v-btn right absolute @click="$emit('close')" class="dialog-close-btn" icon><v-icon color="primary">mdi-close</v-icon></v-btn>
            </v-card-title>
            <v-card-subtitle>There are {{ $helpers.formatNumber(selectedDeleteItem.keyword_count) }} keywords in this category!</v-card-subtitle>
            <v-card-text>
                <div>
                    <!-- <div>There are {{ $helpers.formatNumber(selectedDeleteItem.keyword_count) }} keywords in this category!</div> -->
                    <!-- <div>What should we do with the assigned keywords?</div> -->
                </div>
                <v-radio-group v-model="option" row>
                    <v-radio label="Delete all keywords" value="delete"></v-radio>
                    <v-radio label="Assign to another category" value="move"></v-radio>
                </v-radio-group>
                <v-slide-x-transition>
                    <div v-if="option == 'move'">
                        <v-autocomplete
                            placeholder="Select category..."
                            append-icon="mdi-chevron-down"
                            class="mt-2"
                            v-model="selectedCategory"
                            :items="targetCategories"
                            rounded
                            item-text="category_id"
                            filled
                            hint="Type to search..."
                            return-object>
                            <template v-slot:selection="{ item, index }">
                                <span class="">
                                    <span v-for="(cat, index) in item.category_id.split(';')" :key="cat">
                                        <v-icon v-if="index" small class="px-0">mdi-chevron-right</v-icon>
                                        <v-chip small> {{ cat }}</v-chip>
                                    </span>
                                </span>
                            </template>
                            <template v-slot:item="data">
                                <span class="">
                                    <span v-for="(cat, index) in data.item.category_id.split(';')" :key="cat">
                                        <v-icon v-if="index" small class="px-0">mdi-chevron-right</v-icon>
                                        <v-chip small> {{ cat }}</v-chip>
                                    </span>
                                </span>
                            </template>
                        </v-autocomplete>
                    </div>
                </v-slide-x-transition>
                <!-- Warum der Button gesperrt ist: Umhaengen braucht ein Ziel ausserhalb des geloeschten Teilbaums -->
                <div v-if="option == 'move' && !canDelete" class="text-caption text-center mt-3">
                    To reassign the keywords, select a category outside the one being deleted – it will be deleted together with all of its subcategories.
                </div>
            </v-card-text>

            <v-card-actions>
                <v-btn rounded :loading="loading" :disabled="!canDelete" class="mx-auto" color="primary" v-on:click="deleteCategory()">delete Category</v-btn>
            </v-card-actions>
        </v-card>
        <v-snackbar v-if="notification" top v-model="notification.show" :color="notification.color">
            <v-icon>{{ notification.icon }}</v-icon>
            <span class="font-weight-bold pl-2"> {{ notification.message }} </span>
        </v-snackbar>
    </v-dialog>
</template>

<script>
    export default {
        props: {
            show: Boolean,
            selectedDeleteItem: Object
        },
        data() {
            return {
                loading: false,
                option: "delete",
                selectedCategory: null,
                categories: [],
                notification: null
            }
        },
        computed: {
            categoryName() {
                let split = this.selectedDeleteItem.category_id.split(";")
                return split[split.length - 1]
            },
            // Ziele ohne die zu loeschende Kategorie und ihre Unterkategorien - die werden mitgeloescht
            targetCategories() {
                return this.categories.filter((c) => !this.isInDeletedCategory(c.category_id))
            },
            // Umhaengen nur mit gueltigem Ziel ausserhalb des geloeschten Teilbaums
            canDelete() {
                if (this.option != "move") return true
                return !!(this.selectedCategory && !this.isInDeletedCategory(this.selectedCategory.category_id))
            }
        },
        methods: {
            isInDeletedCategory(category_id) {
                const deletedId = this.selectedDeleteItem ? this.selectedDeleteItem.category_id : ""
                return !!deletedId && (category_id === deletedId || String(category_id).indexOf(deletedId + ";") === 0)
            },
            async fetchCategories() {
                try {
                    this.fetchingCats = true
                    const url =
                        (JSON.parse(process.env.VUE_APP_MONITORING_PROXY_COMPANY_IDS).indexOf(
                            this.CryptoJS.AES.decrypt(localStorage.company_id, process.env.VUE_APP_ENCRYPTION_PW).toString(this.CryptoJS.enc.Utf8)
                        ) == -1
                            ? process.env.VUE_APP_MONITORING_API_URL
                            : process.env.VUE_APP_APIURL + "/monitoring-api") + "/project/get/categories"
                    let post_data = {
                        company_id: localStorage.company_id,
                        project_id: this.$route.params.id
                    }
                    let response_data = await this.$helpers.axiosPost(url, post_data)
                    this.categories = response_data.data.categories.sort((a, b) => a.category_id.localeCompare(b.category_id))
                    console.log(this.categories)

                    this.fetchingCats = false
                } catch (error) {
                    console.log(error)
                }
            },

            async deleteCategory() {
                console.log(this.option)
                console.log(this.selectedCategory)
                if (this.selectedDeleteItem && this.canDelete) {
                    const url =
                        (JSON.parse(process.env.VUE_APP_MONITORING_PROXY_COMPANY_IDS).indexOf(
                            this.CryptoJS.AES.decrypt(localStorage.company_id, process.env.VUE_APP_ENCRYPTION_PW).toString(this.CryptoJS.enc.Utf8)
                        ) == -1
                            ? process.env.VUE_APP_MONITORING_API_URL
                            : process.env.VUE_APP_APIURL + "/monitoring-api") + "/project/delete/category"
                    let post_data = {
                        company_id: localStorage.company_id,
                        project_id: this.$route.params.id,
                        option: this.option,
                        categoryToDelete: this.selectedDeleteItem,
                        newCat: this.selectedCategory
                    }
                    this.loading = true
                    try {
                        let response_data = await this.$helpers.axiosPost(url, post_data)
                        console.log(response_data.data)
                    } catch (error) {
                        console.log(error)
                        this.notification = this.$helpers.createNotification(
                            "The category could not be deleted. Please try again or contact support.",
                            "mdi-alert",
                            "orange darken-2"
                        )
                        return
                    } finally {
                        this.loading = false
                    }
                    setTimeout(() => {
                        this.success = true
                        setTimeout(() => {
                            this.$emit("catDeleted")
                        }, 300)
                    }, 300)
                }
            }
        },
        watch: {
            show(val) {
                if (val) {
                    // jedes Oeffnen startet ohne die Auswahl einer vorher geoeffneten Kategorie
                    this.option = "delete"
                    this.selectedCategory = null
                    this.notification = null
                    this.success = false
                    this.fetchCategories()
                }
            }
        }
    }
</script>

<style></style>
